export default __webpack_public_path__ + "static/bullet-tick-56e439dd18090e60cb57029c35db3f4d.svg";